export const home = {
  '@context': 'http://schema.org',
  '@type': 'WebSite',
  name: 'Vuse Vape Store Online',
  url: ' https://www.vuse.com',
  about:
    ' Vuse offers you the very best vape kits to kick start your vaping experience and competitive prices. Take a look here today. Discover a wide range of e-juices, pods and vape devices.',
  sameAs: [
    'https://www.facebook.com/VypeCanada/',
    'https://www.instagram.com/govypeca/',
    'https://twitter.com/govypeca'
  ]
}

export const epod = {
  '@context': 'http://schema.org',
  '@type': 'Product',
  description:
    'Vuse ePod Starter Kit - pod based system, stylish and compact. Vuse ePod is puff activated and delivers a range of intense flavours with nicotine salts.',
  name: 'Vuse ePod',
  url: 'https://www.vuse.com/vype-epod-starter-kit',
  image: 'https://www.vuse.com/ca/en/images/share-image.png',
  offers: {
    '@type': 'Offer',
    availability: 'http://schema.org/InStock',
    price: '8.99',
    priceCurrency: 'CAD'
  }
}

export const epodFaq = {
  '@context': 'http://schema.org',
  '@type': 'QAPage',
  mainEntity: {
    '@type': 'Question',
    name: 'What is an ePod and how to use it?',
    answerCount: '21',
    acceptedAnswer: {
      '@type': 'Answer',
      text:
        'The Vuse ePod is stylish and compact. This puff activated vaping device delivers intense flavours with its vPRO nicotine salt cartridges. Experience real taste draw and satisfaction. '
    },
    suggestedAnswer: {
      '@type': 'Answer',
      text:
        'To get the most from your Vuse ePod, please follow the instructions for use as stated on the user guide. Only charge your Vuse ePod with the magnetic USB charging cable provided in the starter kit or with Vuse compatible charging accessories. Only use your Vuse ePod with Vuse ePod cartridges. Keep your Vuse ePod, charging accessories and cartridges dry when in storage and during use, as precipitation, humidity or moisture can corrode electronic circuits.',
      url: 'https://www.vuse.com/faq/what-is-vype-epod-how-to-use-it'
    }
  }
}

export const epenFaq = {
  '@context': 'http://schema.org',
  '@type': 'QAPage',
  mainEntity: {
    '@type': 'Question',
    name: 'What is Vuse ePen 3 and how to use it?',
    answerCount: '14',
    acceptedAnswer: {
      '@type': 'Answer',
      text:
        ' The Vuse ePen 3 is a closed-system vaping device that delivers rich vapour and intense taste. This premium design is available in a range of colours, flavours, and nicotine strengths.'
    },
    suggestedAnswer: {
      '@type': 'Answer',
      text:
        ' How do I look after my Vuse ePen 3? To get the most from your Vuse ePen 3, please follow the instructions for use as stated on the user guide: Only charge your Vuse ePen 3 with the charging USB cable provided in the starter kit. Only use your Vuse ePen 3 with Vuse ePen 3 cartridges. Keep your Vuse ePen 3, charging USB cable and cartridges dry when in storage and during use, as precipitation, humidity or moisture can corrode electronic circuits.',
      url: 'https://www.vuse.com/faq/what-is-vype-epen3-how-to-use-it'
    }
  }
}
